import { Thumbnail } from '@shopify/polaris';
import React from 'react';
import { transformToCdnUrl } from 'utils/google-storage-util';
import { PackageProviderName } from '../../../data/ppoints/constants';

export const getPackageProviderIconUrl = (provider: PackageProviderName): string => {
    let iconUrl = '';

    switch (provider) {
        case PackageProviderName.FOXPOST:
        case PackageProviderName.KVIKK_FOXPOST:
            iconUrl = transformToCdnUrl('shipping-providers-logos/foxpost-packeta-group.webp');
            break;
        case PackageProviderName.MPL_PACKAGE_POINT:
        case PackageProviderName.MPL_DELIVERY:
        case PackageProviderName.KVIKK_MPL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/magyar-posta-mpl.webp');
            break;
        case PackageProviderName.MPL_COOP:
            iconUrl = transformToCdnUrl('shipping-providers-logos/coop.svg');
            break;
        case PackageProviderName.MPL_MOL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/mol.svg');
            break;
        case PackageProviderName.MPL_MEDIAMARKT:
            iconUrl = transformToCdnUrl('shipping-providers-logos/mediamarkt.svg');
            break;
        case PackageProviderName.MPL_OFFICE:
            iconUrl = transformToCdnUrl('shipping-providers-logos/posta_32x32.png');
            break;
        case PackageProviderName.GLS:
        case PackageProviderName.KVIKK_GLS:
            iconUrl = transformToCdnUrl('shipping-providers-logos/gls.webp');
            break;
        case PackageProviderName.PACKETA:
        case PackageProviderName.KVIKK_PACKETA:
            iconUrl = transformToCdnUrl('shipping-providers-logos/packeta.webp');
            break;
        case PackageProviderName.DPD:
        case PackageProviderName.KVIKK_DPD:
            iconUrl = transformToCdnUrl('shipping-providers-logos/dpd.webp');
            break;
        case PackageProviderName.SPRINTER:
            iconUrl = transformToCdnUrl('shipping-providers-logos/sprinter-pickpackpoint.webp');
            break;
        case PackageProviderName.TOURMIX:
            iconUrl = transformToCdnUrl('shipping-providers-logos/tourmix.webp');
            break;
        case PackageProviderName.FAN_COURIER_INTERNATIONAL:
            iconUrl = transformToCdnUrl('shipping-providers-logos/fan_courier.webp');
            break;
        default:
            iconUrl = transformToCdnUrl('shipping-providers-logos/' + provider + '.webp');
            break;
    }

    return iconUrl;
};

export const PackageProviderIcon: React.FC<PackageProviderIconProps> = ({ provider, size = 'medium' }) => {
    return <Thumbnail size={size} source={getPackageProviderIconUrl(provider)} alt={provider} />;
};

type PackageProviderIconProps = {
    provider: PackageProviderName;
    size?: 'extraSmall' | 'small' | 'medium' | 'large';
};
